import * as React from "react";
const SvgFiRrPenSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pen-slash_svg__a)">
      <path
        fill="#062147"
        d="M11.651 16.124a1 1 0 0 1 0 1.414L6.71 22.48A5.16 5.16 0 0 1 3.04 24H1a1 1 0 0 1-1-1v-2.039c0-1.386.54-2.689 1.521-3.67l5.05-5.05a.999.999 0 1 1 1.413 1.414l-5.049 5.05A3.17 3.17 0 0 0 2 20.961v1.04h1.04c.852 0 1.652-.333 2.254-.936l4.942-4.94a1 1 0 0 1 1.414 0zm12.056 7.583a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293L10.113 8.7l7.624-7.625a3.675 3.675 0 0 1 5.19 0 3.674 3.674 0 0 1 0 5.19l-7.625 7.623 8.406 8.406a1 1 0 0 1 0 1.414M16.661 4.978l2.361 2.361 2.49-2.489c.65-.65.65-1.71 0-2.36a1.673 1.673 0 0 0-2.362 0zm-5.134 5.135 2.36 2.36 3.721-3.72-2.36-2.36z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pen-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPenSlash;
